import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-radv-diagnosis-data-dw",
  templateUrl: "./radv-diagnosis-data-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadvDiagnosisDataDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.RADV_DIAGNOSIS_DATA;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME];
}
